import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
  CircularProgress,
  useTheme,
  Typography
} from "@mui/material";

const AddProductDialog = ({
  open,
  onClose,
  onSubmit,
  product,
  quantity,
  note,
  price, // ✅ Receive product price
  onQuantityChange,
  onNoteChange,
  onPriceChange, // ✅ Add handler for price change
  loading,
  sendToKitchen = true,
  onSendToKitchenChange,
  preparing_time, // NEW prop
  is_preparing // NEW prop
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  

  // تنفيذ الإضافة عند الضغط على Enter
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
          border: "1px solid rgba(251, 194, 235, 0.2)",
          color: "#fff",
          boxShadow: "0 12px 48px rgba(0, 0, 0, 0.3)",
          backdropFilter: "blur(10px)",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 700,
          fontSize: 22,
          color: "#fbc2eb",
          textAlign: "center",
          borderBottom: "1px solid rgba(251, 194, 235, 0.1)",
          pb: 2,
          background: "linear-gradient(135deg, rgba(251, 194, 235, 0.05) 0%, transparent 100%)",
        }}
      >
        {product?.name}
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2.5,
          mt: 2,
          px: 3,
        }}
        onKeyDown={handleKeyDown}
      >
        <TextField
          label="الكمية"
          type="number"
          value={quantity}
          onChange={onQuantityChange}
          fullWidth
          variant="outlined"
          sx={{
            "& .MuiOutlinedInput-root": {
              bgcolor: "rgba(255, 255, 255, 0.05)",
              borderRadius: 3,
              transition: "all 0.3s ease",
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.1)",
              },
              "&:hover fieldset": {
                borderColor: "rgba(251, 194, 235, 0.5)",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#fbc2eb",
                borderWidth: 2,
              },
              "& input": {
                fontWeight: 700,
                fontSize: 24,
                textAlign: "center",
                color: "#fff",
              },
            },
            "& .MuiInputLabel-root": {
              color: "rgba(255, 255, 255, 0.7)",
              fontWeight: 600,
              "&.Mui-focused": {
                color: "#fbc2eb",
              },
            },
          }}
          inputProps={{ min: 1, style: { textAlign: "center" } }}
        />
        <TextField
          label="السعر"
          type="number"
          value={price}
          onChange={onPriceChange}
          fullWidth
          variant="outlined"
          sx={{
            "& .MuiOutlinedInput-root": {
              bgcolor: "rgba(255, 255, 255, 0.05)",
              borderRadius: 3,
              transition: "all 0.3s ease",
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.1)",
              },
              "&:hover fieldset": {
                borderColor: "rgba(251, 194, 235, 0.5)",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#fbc2eb",
                borderWidth: 2,
              },
              "& input": {
                fontWeight: 700,
                fontSize: 24,
                textAlign: "center",
                color: "#fbc2eb",
              },
            },
            "& .MuiInputLabel-root": {
              color: "rgba(255, 255, 255, 0.7)",
              fontWeight: 600,
              "&.Mui-focused": {
                color: "#fbc2eb",
              },
            },
          }}
          inputProps={{ min: 0, style: { textAlign: "center" } }}
        />
        <TextField
          label="ملاحظات"
          value={note}
          onChange={onNoteChange}
          multiline
          rows={3}
          fullWidth
          variant="outlined"
          sx={{
            "& .MuiOutlinedInput-root": {
              bgcolor: "rgba(255, 255, 255, 0.05)",
              borderRadius: 3,
              transition: "all 0.3s ease",
              "& fieldset": {
                borderColor: "rgba(255, 255, 255, 0.1)",
              },
              "&:hover fieldset": {
                borderColor: "rgba(251, 194, 235, 0.5)",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#fbc2eb",
                borderWidth: 2,
              },
              "& textarea": {
                color: "#fff",
              },
            },
            "& .MuiInputLabel-root": {
              color: "rgba(255, 255, 255, 0.7)",
              fontWeight: 600,
              "&.Mui-focused": {
                color: "#fbc2eb",
              },
            },
          }}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={sendToKitchen}
              onChange={onSendToKitchenChange}
              sx={{
                color: "rgba(255, 255, 255, 0.5)",
                "&.Mui-checked": {
                  color: "#fbc2eb",
                },
                "&:hover": {
                  bgcolor: "rgba(251, 194, 235, 0.1)",
                },
              }}
            />
          }
          label="تجهيز الصنف؟ نعم (حالة: ) / لا (حالة: )"
          sx={{
            color: "#fff",
            fontWeight: 600,
            "& .MuiFormControlLabel-label": {
              fontSize: 15,
            },
          }}
        />
        {(typeof preparing_time !== "undefined" && preparing_time !== null) ||
        (typeof is_preparing !== "undefined" && is_preparing !== null) ? (
          <Box
            sx={{
              bgcolor: "rgba(251, 194, 235, 0.08)",
              border: "1px solid rgba(251, 194, 235, 0.2)",
              borderRadius: 3,
              p: 2,
              mt: 1,
            }}
          >
            {typeof preparing_time !== "undefined" && preparing_time !== null && (
              <Typography variant="body2" sx={{ color: "#fff", fontWeight: 600, mb: 0.5 }}>
                ⏱️ وقت التحضير: <span style={{ color: "#fbc2eb" }}>{preparing_time} دقيقة</span>
              </Typography>
            )}
            {typeof is_preparing !== "undefined" && is_preparing !== null && (
              <Typography variant="body2" sx={{ color: "#fff", fontWeight: 600 }}>
                🍳 يحضّر: <span style={{ color: Number(is_preparing) ? "#81c784" : "#e57373" }}>
                  {Number(is_preparing) ? "نعم" : "لا"}
                </span>
              </Typography>
            )}
          </Box>
        ) : null}
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          pt: 2,
          gap: 2,
          borderTop: "1px solid rgba(251, 194, 235, 0.1)",
        }}
      >
        <Button
          onClick={onClose}
          sx={{
            fontWeight: 600,
            color: "#fff",
            bgcolor: "rgba(255, 255, 255, 0.08)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            borderRadius: 3,
            px: 4,
            py: 1.2,
            fontSize: 16,
            transition: "all 0.3s ease",
            "&:hover": {
              bgcolor: "rgba(255, 255, 255, 0.15)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              transform: "translateY(-2px)",
            },
          }}
        >
          إلغاء
        </Button>
        <Button
          onClick={onSubmit}
          disabled={loading}
          variant="contained"
          sx={{
            fontWeight: 700,
            background: "linear-gradient(135deg, #fbc2eb 0%, #ff9a9e 100%)",
            color: "#232334",
            borderRadius: 3,
            px: 5,
            py: 1.2,
            boxShadow: "0 4px 16px rgba(251, 194, 235, 0.4)",
            fontSize: 18,
            transition: "all 0.3s ease",
            "&:hover": {
              background: "linear-gradient(135deg, #ff9a9e 0%, #fbc2eb 100%)",
              boxShadow: "0 6px 24px rgba(251, 194, 235, 0.6)",
              transform: "translateY(-2px)",
            },
            "&:disabled": {
              background: "rgba(255, 255, 255, 0.1)",
              color: "rgba(255, 255, 255, 0.3)",
            },
          }}
        >
          {loading ? <CircularProgress size={22} color="inherit" /> : "إضافة"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddProductDialog;
